import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalPincodeAll: [],
  generalPincode: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalPincodeSlice = createSlice({
  name: "generalPincode",
  initialState,
  reducers: {
    setGeneralPincodeAll: (state, action) => {
      state.generalPincodeAll = action.payload;
    },
    setGeneralPincode: (state, action) => {
      state.generalPincode = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralPincodeAll,
  setGeneralPincode,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalPincodeSlice.actions;

export default generalPincodeSlice.reducer;
